import { styled } from '@mui/material/styles';
import { Box, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  button: {
    minWidth: '210px',
    textTransform: 'none'
  }
}));

export const DeleteIconButton = styled(IconButton)({
  backgroundColor: '#E53935',
  color: 'white',
  width: '48px',
  height: '48px',
  '&:hover': {
    backgroundColor: '#c62828'
  }
});
